import React from "react";
import CenteredContentWrapper from '../elements/CenteredContentWrapper';
import { getImage } from "../../helpers/images";

export default class AmazingSound extends React.PureComponent {
    render() {
        return (
            <div className={'top-double-block what-is-capsule'}>
                <CenteredContentWrapper className={'wrapper'}>
                    <div className={'text-block'}>
                        <div className={'inner'}>
                            <div className={'small-title'}>What is Capsule?</div>
                            <div className={'title'}>Amazing sound,<br/>No hassle</div>
                            <div className={'description'}>
                                Capsule is a suite of high quality virtual instruments, providing great sound right out of the box.
                                <div className={'breaker'}></div>
                                Get your hands on pro-grade sound libraries, with unmatched ease of use.
                            </div>
                        </div>
                    </div>

                    <img alt={'What is Capsule?'} className={'mobile-element'} src={getImage('landing/what-is-capsule-2.webp')}/>
                </CenteredContentWrapper>
            </div>
        );
    }
}

